const namespace = 'BOOKING/PAYMENT/';

export const PRE_PAYMENT = namespace + 'PRE_PAYMENT';
export const POST_PAYMENT = namespace + 'POST_PAYMENT';
export const SET_PAYMENT_USED = namespace + 'SET_PAYMENT_USED';
